export default __webpack_public_path__ + "static/media/Concept2_2.2da61e34.png";